// 3rd party
import * as React from 'react';
import { observer } from 'mobx-react';

import { updateSearch } from 'bernie-core';
import { useHistory, useLocation } from 'react-router-dom';

interface MoreInformationDialogTriggerButtonProps {
  id: string;
  className?: string;
  onClick?: () => void;
}

const MoreInformationDialogTriggerButton = observer(
  // tslint:disable-next-line:no-shadowed-variable
  function MoreInformationDialogTriggerButton(props: MoreInformationDialogTriggerButtonProps) {
    const { id, onClick, ...otherProps } = props;

    const history = useHistory();
    const location = useLocation();

    const dialogId = `more-information-${id.toLowerCase()}`;

    function handleClick(event) {
      event.preventDefault();

      // TODO: Add dialog trigger button click tracking

      updateSearch({ history, location, newParams: { pwaDialog: dialogId } });

      onClick?.();
    }

    return <button {...otherProps} onClick={handleClick} />;
  },
);

export { MoreInformationDialogTriggerButton };
